(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["deen-pdp-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
  function track(el) { return el.closest('.deen-sw').querySelector('.deen-sw__track'); }
  function update(t) {
    var w = t.closest('.deen-sw__wrap'); if (!w) return;
    var max = t.scrollWidth - t.clientWidth - 2;
    w.classList.toggle('has-prev', t.scrollLeft > 2);
    w.classList.toggle('has-next', t.scrollLeft < max);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sw-dir]'); if (!b) return;
    var t = track(b);
    t.scrollBy({ left: parseInt(b.dataset.swDir, 10) * t.clientWidth * 0.75, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('deen-sw__track')) update(e.target);
  }, true);
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('.deen-sw__item'); if (!a) return;
    var l = a.closest('.deen-sw').querySelector('[data-sw-name]'); if (l) l.textContent = a.dataset.name;
  });
  document.addEventListener('mouseout', function (e) {
    var a = e.target.closest && e.target.closest('.deen-sw__item'); if (!a) return;
    var l = a.closest('.deen-sw').querySelector('[data-sw-name]'); if (l) l.textContent = l.dataset.swOrig;
  });
  function init() {
    document.querySelectorAll('.deen-sw__track').forEach(function (t) {
      var sel = t.querySelector('.is-selected');
      if (sel && t.scrollWidth > t.clientWidth) t.scrollLeft = Math.max(0, sel.offsetLeft - 12);
      update(t);
    });
  }
  window.addEventListener('load', init);
  window.addEventListener('resize', init);
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
  } catch(e) { console.error(e); }
})();

})();
